<template>
  <div class="taskTableHeader">
      <h3 class="title">{{title}}</h3>
  </div>
</template>

<script>
export default {
  name: 'TaskTableHeader',
  props: ['title', 'search', 'chooseAll', 'chooseNone', 'chooseRead', 'chooseUnread', 'markRead', 'markUnread', 'deleteMsg'],
};
</script>

<style src="./TaskTableHeader.scss" lang="scss" scoped />
